import Deck from "components/Deck";
import Layout from "components/Layout";
import Trainers from "components/Trainers";
import RATINGS from "constants/ratings";
import useConfigStorage from "storage/config";
import ITrainer from "types/Trainer";
import { jsonTrainers } from "utils/json";
import RatingUtils from "utils/rating";
import { FunctionComponent, useEffect, useMemo, useState } from "react";
import useRosterStorage from "storage/roster";
import { useParams } from "react-router";

type Props = {};

const PublicRosterPage: FunctionComponent<Props> = () => {
  const [trainers, setTrainers] = useState<ITrainer[]>([]);
  const [selected, setSelected] = useState<ITrainer[]>([]);
  const [config, setConfig] = useState(RATINGS);

  const { id } = useParams<{ id: string }>();

  const { getRoster } = useRosterStorage();

  const updateTrainers = async () => {
    const roster = await getRoster(id);

    setTrainers(roster.trainers);
  };

  useEffect(() => {
    updateTrainers();
  }, []);

  const { getConfig } = useConfigStorage();

  useEffect(() => {
    getConfig().then((config) => {
      if (config) {
        setConfig(config as typeof RATINGS);
      }
    });

    // const _trainers = Object.entries(query)
    //   .map(([name, level]) => {
    //     const trainer = jsonTrainers.find((t) => t.name === name);

    //     if (!trainer) {
    //       return undefined;
    //     }

    //     return {
    //       ...trainer,
    //       level: +level,
    //     };
    //   })
    //   .filter(Boolean);

    // if (_trainers.length > 0) {
    //   setTrainers(Utils.updateTrainers(trainers, _trainers));
    //   setSelected(_trainers);
    // }
  }, []);

  const updateQueryString = () => {
    if (selected.length > 0) {
      const queryString = selected.map((trainer) => `${trainer.name}=${trainer.level}`).join("&");

      // const url = router.pathname;
      // const baseAsPath = `/roster/${router.query.id}`;
      // const asPath = `${baseAsPath}?${queryString}`;

      // router.push(url, asPath, { shallow: true });
    }
  };

  useEffect(() => {
    updateQueryString();
  }, [selected]);

  const _Trainers = (
    <Trainers
      trainers={trainers}
      setTrainers={setTrainers}
      selected={selected}
      setSelected={setSelected}
      maxSelected={6}
    />
  );

  const ratedDeck = RatingUtils.rateDeck(selected, { position: "any", positionType: "any", team: "any" }, config);

  const onTrainerClick = (trainer: ITrainer) => {
    setSelected(selected.filter((t) => t.name !== trainer.name));
  };

  return (
    <Layout>
      {/* <Head>
        <meta property="og:title" content="Roster | Deck Generator Baseball Superstars 2020"></meta>
        <meta property="og:description" content="Save your Baseball Superstars 2020's Roster"></meta>
        <title>Roster | Deck Generator Baseball Superstars 2020</title>
      </Head> */}

      <div
        style={{
          textAlign: "center",
          padding: "32px",
          height: "100%",
          overflow: "scroll",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Deck
            trainers={selected}
            skills={ratedDeck.skills}
            events={ratedDeck.events}
            position={ratedDeck.position}
            team={ratedDeck.team}
            rating={ratedDeck.rating}
            onTrainerClick={onTrainerClick}
          />
        </div>
        <div style={{ flex: "1", minHeight: "0" }}>{_Trainers}</div>
      </div>
    </Layout>
  );
};

export default PublicRosterPage;
